import React from 'react';

import ReactDOM from 'react-dom/client';

import './index.css';
import './styles/sweetalert-custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import './components/common/ToastManager';
import { initAnalytics } from './services/analytics';

// Initialize Google Analytics (only in production)
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker registration disabled - Phase 1 PWA (installability only)
// Will be re-enabled in Phase 2 when caching strategy is implemented
// serviceWorker.register();
